<template>

</template>

<script>
export default {
  name: "CLOProposalsPage"
}
</script>


